import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=51efb0e0&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51efb0e0')) {
      api.createRecord('51efb0e0', component.options)
    } else {
      api.reload('51efb0e0', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=51efb0e0&", function () {
      api.rerender('51efb0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/login2/views/ResetPassword.vue"
export default component.exports